<template>
  <el-row class="cci-search-row">
    <el-col :span="12">
      <search-input
        placeholder="Поиск по телефону, ФИО"
        @clear="clearFilter"
        @input="onInput"
        @search="onSearch"
      />
    </el-col>
    <el-col :span="12" class="ta-r">
      <additional-menu @add="setModal(true)" />
    </el-col>
    <add-contact-modal :visible="visible" @close="setModal" />
  </el-row>
</template>

<script>
import AddContactModal from './Modals/AddContactModal'
import AdditionalMenu from '@/views/CallCenter/components/AdditionalMenu'
import SearchInput from '@/components/Shared/SearchInput'

export default {
  name: 'SearchBlock',
  components: { SearchInput, AdditionalMenu, AddContactModal },
  data() {
    return {
      search: '',
      visible: false,
    }
  },
  methods: {
    onInput(cur) {
      this.search = cur
    },
    clearFilter() {
      this.$emit('search')
    },
    onSearch() {
      this.$emit('search', this.search)
    },
    setModal(flag = false) {
      this.visible = flag
    },
  },
}
</script>

<style lang="sass">
.cci-search-row
  margin-bottom: 30px
</style>
